import type { QueryClient } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet, useRouterState } from '@tanstack/react-router'

import { Empty, FatalError, Loading } from '../components/Card'
import { Nav } from '../components/Nav'
import { Screen } from '../components/Screen'
import { ToastProvider } from '../components/Toast'
import { t } from '../i18n'
import { useLanguageSync } from '../lib/language'
import { settingsQuery } from '../lib/queries'

const ROOTS = new Set(['/', '/week', '/products', '/spf', '/more'])

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: Root,
  pendingComponent: () => (
    <div className="backdrop-blobs flex min-h-dvh items-center justify-center">
      <Loading />
    </div>
  ),
  errorComponent: ({ error }) => <FatalError message={error.message} />,
  notFoundComponent: () => (
    <Screen title={t.common.notFoundTitle}>
      <Empty title={t.common.notFoundHint} />
    </Screen>
  ),
})

function Root() {
  const path = useRouterState({ select: (state) => state.location.pathname })
  const { data: settings } = useQuery(settingsQuery())

  useLanguageSync(settings)

  return (
    <ToastProvider>
      <Outlet />
      {ROOTS.has(path) ? <Nav /> : null}
    </ToastProvider>
  )
}
